<template>
  <div class="recipe-slider" @mouseenter="addHoverFocus" @mouseover="addHoverFocus" @mouseout="removeHoverFocus"
       @mouseleave="removeHoverFocus" tabindex="0">
    <mu-card>
      <div class="title">
        <mu-row style="align-items: center">
          <mu-col desktop="50" tablet="50" width="50">
            <mu-content-block class="title" style="padding-top:0px;padding-bottom: 0" v-once>
              {{title}}
            </mu-content-block>
          </mu-col>
          <mu-col desktop="50" tablet="50" width="50" align="right">
            <mu-content-block style="padding-top: 0px;padding-bottom:0">
              <mu-raised-button @click.native="goToGroupingCategory" label="See all"></mu-raised-button>
            </mu-content-block>
          </mu-col>
        </mu-row>
      </div>
      <div :id="'scrolling-recipe-' + id" class="owl-carousel horizontal-scroller scrolling-wrapper">
        <recipe-card
          v-for="item, recipeI in recipes"
          :key="'recipe-' + recipeI + _uid"
          v-once

          @mouseenter.native="addRecipeTween"
          @mouseleave.native="removeRecipeTween"

          :recipe="item"></recipe-card>
      </div>
    </mu-card>
  </div>
</template>
<script>
  import 'owl.carousel'
  import 'owl.carousel/dist/assets/owl.theme.default.css'
  import 'owl.carousel/dist/assets/owl.carousel.min.css'
  import $ from 'jquery'
  import RecipeCard from "./RecipeCard";
  import MuRaisedButton from "muse-ui/src/raisedButton/raisedButton";
  import MuContentBlock from "muse-ui/src/contentBlock/contentBlock";
  import {TweenMax, Power2, TimelineLite} from 'gsap'

  export default {
    components: {
      MuContentBlock,
      MuRaisedButton,
      RecipeCard
    },
    name: "horizontal-scroller",
    props: ['recipes', 'title', 'linkTo', 'groupingType', 'groupingRoute'],
    data() {
      return {
        id: this._uid,
        isHoverFocused: false,
        owl: null
      }
    },
    mounted() {
      let self = this;
      self.box = $('#scrolling-recipe-' + self.id);
      self.$nextTick(function () {
        self.owl = self.box.owlCarousel({
          loop: false,
          nav: true,
          margin: 16,
          responsiveClass: true,
          navText: ['<button style="background: white;" class="mu-icon-button"><i class="material-icons" aria-hidden="true">keyboard_arrow_left</i></button>', '<button style="background: white;" class="mu-icon-button"><i class="material-icons" aria-hidden="true">keyboard_arrow_right</i></button>'],
          responsive: {
            0: {
              items: 2,
              slideBy: 2,
            },
            800: {
              slideBy: 3,
              items: 3,
              stagePadding: 100
            },
            1000: {
              slideBy: 4,
              items: 4,
              stagePadding: 100
            },
            1100: {
              slideBy: 4,
              items: 4,
              stagePadding: 100
            },
            1024: {
              slideBy: 4,
              items: 4,
            },
            1200: {
              slideBy: 3,
              items: 3,
              stagePadding: 100
            },
            1500: {
              items: 5,
              slideBy: 5,
              stagePadding: 100
            },
            10000: {
              items: 6,
              slideBy: 6,
              stagePadding: 100
            }
          },
          afterMove: function () {
            if (this.currentItem === this.maximumItem) {
              alert(
                $('.owl-item').eq(this.maximumItem)
              )
            }
          }
        });
        $(self.$el).on('keyup', self.onKeyboardEvent);
      })
    },
    methods: {
      addRecipeTween(ev) {
        if(this.owl === null) {
          return false;
        }

        let el = ev.target;
        let parent = el.parentElement;
        if (!$(parent).hasClass('bringToFront')) {
          $(parent).addClass('bringToFront');
          TweenMax.to(el.firstChild, .2, {scaleX: 1.1, scaleY: 1.1});
        }

      },
      removeRecipeTween(ev) {
        if(this.owl === null) {
          return false;
        }

        let el = ev.target;
        let parent = el.parentElement;
        if ($(parent).hasClass('bringToFront')) {
          $(parent).removeClass('bringToFront');
          TweenMax.to(el.firstChild, .2, {scaleX: 1, scaleY: 1});
        }
      },
      addHoverFocus() {
        let self = this;
        self.isHoverFocused = true;
        self.$nextTick(function () {
          self.$el.focus({
            preventScroll: true
          }, function() {
            return false;
          });
        },500);
        self.$forceUpdate();
      },
      removeHoverFocus() {
        let self = this;
        self.isHoverFocused = false;
        $(self.$el).blur();
        self.$forceUpdate();
      },
      goToGroupingCategory() {
        let self = this;
        self.$router.push({
          name: 'RecipeCategory',
          query: {
            grouping: self.groupingType,
            route: self.groupingRoute
          }
        });
      },
      invalidateOldActiveTile() {
        let self = this;
        let $scrollingWrapper = $('#scrolling-recipe-' + self.id + ' .owl-stage .owl-item');
        $scrollingWrapper.each(function (el, item) {
          let $item = $scrollingWrapper.eq(el);
          if ($item.hasClass('bringToFront')) {
            $item.removeClass('bringToFront');
            let firstChild = $scrollingWrapper.eq(el).find('.recipe-item')[0];
            TweenMax.to(firstChild.firstChild, .2, {scaleX: 1, scaleY: 1, opacity: 1});
          }
        });
      },
      onKeyboardEvent(e) {
        let self = this;
        let key = e.keyCode ? e.keyCode : e.which;
        if (self.isHoverFocused) {
          switch (key) {
            case 68:
            case 39:
              self.invalidateOldActiveTile();
              self.owl.trigger('next.owl.carousel');
              break;
            case 65:
            case 37:
              self.invalidateOldActiveTile();
              self.owl.trigger('prev.owl.carousel');
              break;
          }
        }
        return false;
      }
    }
    ,
    beforeDestroy() {
      let self = this;
      $(self.$el).off('keyup');
    }
  }
</script>


<style>
  .bringToFront {
    z-index: 9999;
  }

  button.owl-prev.disabled {
    display: none !important;
  }

  button.owl-next.disabled {
    display: none !important;
  }

  .owl-carousel {
    z-index: 0 !important;
  }

  .recipe-slider {
    outline: none;
  }

  div#recipes-detail .recipe-slider .mu-card-text {
    background: white !important;
  }

  div#recipes-detail .recipe-slider .mu-card {
    background: transparent !important;
  }

  .recipe-slider .scrolling-wrapper .owl-stage {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .recipe-slider > .mu-card {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }

  .recipe-slider .title .mu-content-block {
    font-size: 18px;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .owl-prev {
    width: 32px;
    height: calc(100% - 8px);
    position: absolute;
    top: 0%;
    left: 16px;
    margin-left: 0px;
    display: block !IMPORTANT;
    border: 0px solid black;
  }

  @media (max-width: 800px) {
    .recipe-slider .owl-prev {
      display: none !important;
    }

    .recipe-slider .owl-next {
      display: none !important;
    }
  }

  .owl-prev button, .owl-next button {
    box-shadow: 0 1px 6px rgba(0, 0, 0, .117647), 0 1px 4px rgba(0, 0, 0, .117647);
  }

  .owl-next {
    width: 32px;
    height: calc(100% - 8px);
    position: absolute;
    top: 0%;
    right: 28px;
    display: block !IMPORTANT;
    border: 0px solid black;
  }

  @media (min-width: 800px) {
    .recipe-slider .owl-stage {
      left: -100px;
    }
  }

  .owl-prev i, .owl-next i {
    color: black;
  }

  .owl-dots {
    display: none;
  }

  .owl-item {
    padding-bottom: 8px;
    padding-top: 2px;
  }

  /**
   * Owl Carousel v2.3.4
   * Copyright 2013-2018 David Deutsch
   * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
   */

  /**

  .recipe-slider {
    margin-bottom: 24px;
    h2 {
      padding-left: 16px;
    }
    .mu-card .title {
      padding-left: 16px;
    }
  }

  .horizontal-scroller {
    &.scrolling-wrapper {
      overflow-x: scroll;
      overflow-y: hidden;
      white-space: nowrap;
      background: #f6f6f6;
      .mu-card {

        margin: 8px;
        margin-right: 4px;
        display: inline-block;

        @media (max-width: 800px) {
          width: 250px;
        }
        @media (min-width: 800px) {
          width: 350px;
        }
        img {
          width: 100%;
        }
      }
    }

  }
  **/
</style>



// WEBPACK FOOTER //
// HorizontalScroller.vue?3bf02c19